import { getSelectedYear } from "../context/YearContext.js";

// let isDev = process.env.NODE_ENV === "development";
let isDev = true;

// let domain = "http://localhost:8080";
// let domain = "http://ec2-13-125-213-158.ap-northeast-2.compute.amazonaws.com:8080";
let domain = "https://bowapi.thesoomco.com"
let normalAPI = domain + (isDev ? "/user-apigate-web-open" : "/user-apigate-web-open");
let openAPI = domain + (isDev ? "/user-apigate-web-open" : "/user-apigate-web-open");
let authAPI = domain + (isDev ? "/admin-apigate-test" : "/admin-apigate-auth");
let logoutAPI = domain + (isDev ? "/admin-apigate-test" : "/admin-apigate-logout");
let fileAPI = domain + (isDev ? "/admin-apigate-resource-test" : "/admin-apigate-resource");
export let certificateUrl = domain + (isDev ? "/certificate-start" : "/certificate-start");

export let userTokenName = "bow_admin_token";

let userToken = isDev ? localStorage.getItem(userTokenName) : null;

export async function request(json, callback) {
  return await requestBase(normalAPI, json, callback);
}

export async function requestOpen(json, callback) {
  return await requestBase(openAPI, json, callback);
}

export async function requestLogout(json, callback) {
  return await requestBase(normalAPI, json, callback);
}

export async function requestToken(json, callback) {
  return await requestBase(authAPI, json, callback);
}

export function requestFileAPI(json, fileArray, callback) {
  requestFileBase(fileAPI, json, fileArray, callback);
}

export function requestBlobAPI(json, blobArray, callback) {
  requestBlobBase(fileAPI, json, blobArray, callback);
}

export function requestFileBase(api, json, fileArray, callback) {
  if (isDev && userToken) json["admin_token"] = userToken;
  if (!json["year"]) json["year"] = getSelectedYear();
  var formData = new FormData();
  var xhr = new XMLHttpRequest();
  xhr.onload = function () {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        var json = JSON.parse(xhr.responseText);
        callback(json["bk-result"], json);
      } else {
        alert("등록 실패:" + xhr.statusText);
      }
    }
  };

  for (var j in fileArray) {
    formData.append("resources", fileArray[j]);
  }

  formData.append("json", JSON.stringify(json));
  xhr.withCredentials = true;
  xhr.open("POST", api);
  xhr.send(formData);
}

export function requestBlobBase(api, json, blobArray, callback) {
  if (isDev && userToken) json["admin_token"] = userToken;
  if (!json["year"]) json["year"] = getSelectedYear();
  var formData = new FormData();
  var xhr = new XMLHttpRequest();
  xhr.onload = function () {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        var json = JSON.parse(xhr.responseText);
        callback(json["bk-result"], json);
      } else {
        alert("등록 실패:" + xhr.statusText);
      }
    }
  };

  for (var j in blobArray) {
    formData.append("resources", blobArray[j].blob, blobArray[j].name);
  }

  formData.append("json", JSON.stringify(json));
  xhr.withCredentials = true;
  xhr.open("POST", api);
  xhr.send(formData);
}

async function requestBase(api, json, callback) {
  if (isDev && userToken) json["admin_token"] = userToken;
  let otherParam = {
    crossDomain: true,
    method: "POST", //TODO DRY!!
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "cache-control": "no-cache", //TODO DRY!!
    },
    credentials: "include",
    body: JSON.stringify({
      year: getSelectedYear(),
      ...json,
      csrf: localStorage.getItem("serviceToken"),
    }),
  };
  return await fetch(api, otherParam) // API call
    .then((dataResp) => {
      return dataResp.json();
    }) // Format API response as JSON
    .then((res) => {
      const result = res["bk-result"];
      if (!result) {
        console.log("오류:" + JSON.stringify(res));
      }
      if (callback != null) callback(result, res);
      return { result, response: res };
    })
    .catch((error) => {
      console.log(error);
      return { result: false, response: null };
    });
}
